import api from './clients';
import { buildQueryString } from '../lib/pagination';

interface GetProductsParams {
  search?: string;
  activo?: boolean | null;
  page?: number;
  limit?: number;
}

export const productsApi = {
  getAll: async (params?: GetProductsParams) => {
    const query = buildQueryString({
      search: params?.search,
      activo: params?.activo,
      page: params?.page,
      limit: params?.limit,
    });

    const response = await api.get(`/products${query}`);
    return response.data;
  },

  getById: async (id: number) => {
    const response = await api.get(`/products/${id}`);
    return response.data?.data || response.data;
  },
  
  getLowStock: async () => {
    const response = await api.get('/products/bajo-stock');
    return response.data?.data || response.data || [];
  },
  
  search: async (query: string) => {
    const response = await api.get(`/products/buscar?q=${query}`);
    return response.data?.data || response.data || [];
  },
  
  create: async (data: any) => {
    const response = await api.post('/products', data);
    return response.data?.data || response.data;
  },
  
  update: async (id: number, data: any) => {
    const response = await api.put(`/products/${id}`, data);
    return response.data?.data || response.data;
  },
  
  updateStock: async (id: number, quantity: number) => {
    const response = await api.put(`/products/${id}/stock`, { quantity });
    return response.data?.data || response.data;
  },
  
  delete: async (id: number) => {
    const response = await api.delete(`/products/${id}`);
    return response.data;
  },

  exportInventario: async () => {
    const response = await api.get('/reports/export-inventario');
    return response.data;
  },
};